async function get(url: string, headers?: any) {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...headers
    }
  });

  return await response.json();
}

async function post(url: string, payload: any, headers?: any) {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...headers
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      console.error('HTTP POST error:', response.status, response.statusText, url);
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error in HTTP POST:', error);
    throw error;
  }
}

async function download(url: string, payload: any, headers?: any) {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers
    },
    body: JSON.stringify(payload)
  });

  return await response;
}

const http = {
  get,
  post,
  download
};

export default http;